var externalFileBusCompanies = [
  "Expreso Brasilia (B1)",
  "1001 (10)",
  "123onibus (12)",
  "Açailândia (0A)",
  "EXPRESSO SAO JOSE (0E)",
  "Nacional (0N)",
  "Expresso Transpen (0P)",
  "Rápido Sumaré (0R)",
  "Santana (0S)",
  "Orion Turismo (0T)",
  "Saritur (0U)",
  "Viação Eldorado (0V)",
  "Expresso Adamantina (0X)",
  "Cruzeiro (0Z)",
  "Aguiar (1A)",
  "Brasileiro (1B)",
  "CANTELLE (1C)",
  "DANUBIO AZUL (1D)",
  "Empresa Manoel Rodrigues (1E)",
  "São Bento (1N)",
  "OURO VERDE (1O)",
  "PETROACRE (1P)",
  "RODOVIARIO SAO BENTO (1R)",
  "Viação São Luiz (1S)",
  "TTL TURISMO (1T)",
  "Ultra (1U)",
  "VIACAO ACAILANDIA (1V)",
  "Expresso Jóia (1X)",
  "Empresa Cruz (1Z)",
  "BRISA2 (2B)",
  "COLITUR (2C)",
  "DANUBIO AZUL (2D)",
  "EXPRESSO DE PRATA (2E)",
  "Nordeste Transportes (2N)",
  "Paraibuna (2P)",
  "RAPIDO ACAILANDIA (2R)",
  "Sudoeste Transportes (2S)",
  "Áries Transportes (2T)",
  "Unesul 2 (2U)",
  "VIACAO PLANETA (2V)",
  "CANTELLE (3C)",
  "EXPRESSO DE PRATA (3E)",
  "BREDA (3R)",
  "SOLIMOES TRANSPORTES DE PASSAGEIROS E CARGAS LTDA (3S)",
  "Viacao Estrela (3V)",
  "Asatur (4A)",
  "EUCATUR RO (4E)",
  "AGUIAR (4G)",
  "Andorinha (4N)",
  "Passaro Marron (4P)",
  "Real Alagoas (4R)",
  "ESMERALDA (4S)",
  "Costa Verde (4V)",
  "SULBA (5B)",
  "Camurujipe (5C)",
  "Expresso kaiowa (5E)",
  "Princesa do Inhamuns (5P)",
  "RD Transportes (5R)",
  "EXPRESSO UNIAO LTDA (5S)",
  "Viação Sampaio (5V)",
  "Brisa (6B)",
  "CANTELLE (6C)",
  "Expresso Brasileiro (6E)",
  "Presidente (6P)",
  "OURO E PRATA RS (6R)",
  "Suassuí (6S)",
  "Santa Cruz (6V)",
  "Crucero del norte (7C)",
  "Expresso Guanabara (7E)",
  "Santana (7S)",
  "Tres amigos (7V)",
  "Facil (8E)",
  "Beltour (8R)",
  "Boa Esperança (8S)",
  "Transbrasiliana (8V)",
  "Expresso Luxo (9E)",
  "Princesa Do Ivaí (9P)",
  "Atual (AL)",
  "JBL Turismo (B0)",
  "Braganca (B5)",
  "Breda (B7)",
  "Rapido Ribeirao (B8)",
  "Ouro Branco (B9)",
  "BRAGANCA (BC)",
  "Bomfim (BM)",
  "Brasil Sul (BS)",
  "Continental (C0)",
  "Catarinense (C7)",
  "Cidade do Aco (C8)",
  "Cisne Branco (CN)",
  "Calvip (CP)",
  "Citral (CR)",
  "São Cristovão (CV)",
  "Danubio Azul (D2)",
  "Rio doce (D3)",
  "Roderotas (D4)",
  "Demon (D5)",
  "Expresso Do Sul (D6)",
  "Expresso Araguari (D7)",
  "Rapido Federal (D9)",
  "DANUBIO AZUL (DA)",
  "Nordeste (DD)",
  "Cidade Sol (DS)",
  "Real Transporte (E2)",
  "Unesul (E3)",
  "Reunidas (E4)",
  "Eucatur (E5)",
  "Expresso Nordeste (E6)",
  "Expresso Itamarati (E7)",
  "Emtram (E8)",
  "Expresso Maringá (E9)",
  "Guerino Seiscento (EE)",
  "Falcão Real (FR)",
  "Transfada (FS)",
  "Rápido Fênix (FX)",
  "Goiânia (G2)",
  "Sao geraldo (G5)",
  "Águia Branca (G6)",
  "Garcia (G7)",
  "Gardênia (G8)",
  "Expresso Setelagoano (G9)",
  "Guarani (GR)",
  "GRACIOSA TRANSPORTES (GS)",
  "GADOTTI (GT)",
  "Helios Coletivos (HC)",
  "Novo horizonte (HZ)",
  "IPe Transportes (II)",
  "Graciosa (IO)",
  "Jaó (J4)",
  "J ARAUJO (JA)",
  "JBL TURISMO LTDA (JB)",
  "Santo Anjo (JS)",
  "SAO JOAO TURISMO (JT)",
  "Kaissara (KS)",
  "Litoranea (L2)",
  "Lopes (L3)",
  "Salutaris (L4)",
  "Unica - facil (L5)",
  "Util (L6)",
  "Real Expresso (L7)",
  "Pluma (L9)",
  "Lira Bus (LB)",
  "Eldorado (LD)",
  "ALFA LUZ (LF)",
  "Planalto Transportes (LL)",
  "Solimões (LM)",
  "LiraBus (LS)",
  "ALFA LUZ (LZ)",
  "Marte Transportes (M0)",
  "Macaense (M2)",
  "Cometa (M3)",
  "Motta (M4)",
  "Itapemirim (M5)",
  "CAMURUJIPE (MJ)",
  "Manoel Rodrigues (MM)",
  "Mudando nomea (MN)",
  "ESMERALDA (MR)",
  "Amatur (MT)",
  "NEUTRO  (N0)",
  "Normandy (N1)",
  "SUL BAIANA (NA)",
  "Reunidas Paulista (ND)",
  "Ingá Tur (NG)",
  "Transnorte (NN)",
  "Nasser (NR)",
  "TRANSPEN (NS)",
  "Santafé (NT)",
  "Nova Integração (NV)",
  "Sol Nascente (ON)",
  "Ouro e Prata (OO)",
  "OURO VERDE (OV)",
  "Piracicabana (P1)",
  "Passaro Verde (P2)",
  "Princesa dos Campos (P3)",
  "Progresso (P4)",
  "Penha (P6)",
  "Aparecida (PC)",
  "Princesa Morena (PM)",
  "Transpen (PN)",
  "Princesa do Norte (PP)",
  "Empresa Eucatur (PT)",
  "Rápido Brasil (R0)",
  "Rapido Marajo (R2)",
  "Teresopolis (R3)",
  "Regional (R4)",
  "REUNIDAS PAULISTA (R5)",
  "RODOVIARIO SAO BENTO (R6)",
  "Rota Transportes (R8)",
  "CERRO AZUL (R9)",
  "Rápido Campinas (RC)",
  "VIACAO RIO DOCE (RD)",
  "CITRAL (RL)",
  "Rio Novo (RN)",
  "Rápido D'Oeste (RP)",
  "Serro (RR)",
  "PLANALTO RS (RS)",
  "Reunidas Turismo (RT)",
  "Serra Azul (RZ)",
  "Satélite Norte (S0)",
  "Viação Sandra (SD)",
  "SANTAFE (SF)",
  "São João Turismo (SJ)",
  "Viasul (SL)",
  "PRINCESA MORENA (SM)",
  "Trans Acreana (SR)",
  "SAO PAULO SAO PEDRO (SS)",
  "São Luiz (SZ)",
  "Transcontinental (T1)",
  "Transbrasiliana (TB)",
  "Edson Turismo (TD)",
  "Gontijo (TJ)",
  "Total (TT)",
  "VAT (TV)",
  "Unica (U2)",
  "Jauá (UJ)",
  "Unida Mansur (UN)",
  "União (UO)",
  "UMUARAMA (UR)",
  "União Santa Cruz (UZ)",
  "EVOLUCAO TRANSPORTES (V1)",
  "Viação Adamantina (V2)",
  "VB Transportes (V4)",
  "Viação Araguarina (V5)",
  "Viação Planalto (V6)",
  "Viação Fretcar (V8)",
  "Viação Cantelle (V9)",
  "VAT (VA)",
  "Verde Transportes (VD)",
  "VIACAO SERTANEJA (VJ)",
  "VALLE SUL (VL)",
  "VIACAO MOTTA (VM)",
  "Viação Progresso (VP)",
  "AUTO VIACAO CRUZEIRO LTDA (VZ)",
  "Expresso de Prata (X0)",
  "EXPRESSO ADAMANTINA (XA)",
  "EXPRESSO SATELITE NORTE LTDA (XD)",
  "Expresso Maia (XI)",
  "EXPRESSO JOIA (XJ)",
  "Expresso Amarelinho (XO)",
  "EXPRESSO ARAGUARI (XR)",
  "EXPRESSO SOLUCAO (XS)",
  "Xavante (XV)",
  "Nacional Expresso WL (XW)",
  "Conexão Nova Lima (XX)",
  "Cruzeiro do Sul (ZR)",
  "Expresso São Luiz (ZS)"
];
